import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';
import PrintIcon from '@mui/icons-material/Print';
import config from '../config/Config';
import { apiHeaderToken } from '../helper/My_Helper';

const AppointmentLatter = ({ candidateData, category = 'Appointment Letter' }) => {
  const [appointmentData, setAppointmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchAppointmentLetter = async () => {
      try {
        setLoading(true);
        const payload = {
          "candidate_id": candidateData?._id,
          "doc_category": category,
          "approval_note_id": candidateData?.applied_jobs?.find(
            (item) => item?.job_id === candidateData?.job_id
          )?.approval_note_data?.doc_id
        };

        const response = await axios.post(
          `${config.API_URL}getCandidateEmailContent`,
          payload,
          apiHeaderToken(config?.API_TOKEN)
        );

        if (response.status === 200 && response.data?.status) {
          const data = response.data?.data;
          const verificationStatus = response.data?.appointment_letter_verification_status;
        
          // Show Appointment Letter only when verification status is Complete
          if (verificationStatus === 'Complete') {
            setAppointmentData(data);
          } else {
            setAppointmentData(null);
          }
        } else {
          setAppointmentData(null);
        }
      } catch (error) {
        console.error(`Error fetching ${category}:`, error);
        setAppointmentData(null);
      } finally {
        setLoading(false);
      }
    };

    if (candidateData?._id) {
      fetchAppointmentLetter();
    }
  }, [candidateData, category]);

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const content = appointmentData?.content_data || '';

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>${category}</title>
        <style>
          @page {
            size: A4;
            margin: 0;
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          /* Ensure all content displays properly */
          .print-wrapper {
            display: block;
            width: 100%;
          }
          
          /* Preserve original styling from your HTML */
          div[style*="position: absolute"],
          div[style*="position: fixed"] {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          /* Fix page breaks */
          .page-break {
            page-break-after: always;
            break-after: page;
          }
          
          /* Ensure background images print */
          img {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          /* Keep watermarks */
          div[style*="watermark"] img,
          img[alt="Watermark"] {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        </style>
      </head>
      <body>
        <div class="print-wrapper">
          ${content}
        </div>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        <\/script>
      </body>
      </html>
    `);

    printWindow.document.close();
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
        <Box ml={2}>Loading {category.toLowerCase()}...</Box>
      </Box>
    );
  }

  if (!appointmentData || !appointmentData?.content_data) {
    return (
      <Box p={3} textAlign="center">
        <p>No {category.toLowerCase()} found for this candidate.</p>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="center" mb={2} className="no-print">
        <Button
          variant="contained"
          color="primary"
          onClick={handlePrint}
          startIcon={<PrintIcon />}
          sx={{ textTransform: 'none' }}
        >
          Print Letter
        </Button>
      </Box>

      <Paper
        elevation={3}
        sx={{
          p: 0,
          backgroundColor: 'white',
          maxWidth: '210mm',
          margin: '0 auto',
          overflow: 'auto',
          minHeight: '297mm',
          boxShadow: { xs: 'none', md: 3 },
        }}
      >
        <div
          ref={printRef}
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: appointmentData.content_data }} />
        </div>
      </Paper>
    </Box>
  );
};

export default AppointmentLatter;